module.exports = __webpack_public_path__ + "static/media/schoolshop.66733936.jpeg";